import SaleDashboardContainer from './SaleDashboardContainer';
export default SaleDashboardContainer;
